import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * DevExtreme (esm/core/templates/template.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../renderer";
import { TemplateBase } from "./template_base";
import { normalizeTemplateElement } from "../utils/dom";
import { getCurrentTemplateEngine, registerTemplateEngine, setTemplateEngine } from "./template_engine_registry";
import "./template_engines";
registerTemplateEngine("default", {
  compile: function compile(element) {
    return normalizeTemplateElement(element);
  },
  render: function render(template, model, index) {
    return template.clone();
  }
});
setTemplateEngine("default");
export var Template = /*#__PURE__*/function (_TemplateBase) {
  _inherits(Template, _TemplateBase);

  var _super = _createSuper(Template);

  function Template(element) {
    var _this;

    _classCallCheck(this, Template);

    _this = _super.call(this);
    _this._element = element;
    return _this;
  }

  _createClass(Template, [{
    key: "_renderCore",
    value: function _renderCore(options) {
      var transclude = options.transclude;

      if (!transclude && !this._compiledTemplate) {
        this._compiledTemplate = getCurrentTemplateEngine().compile(this._element);
      }

      return $("<div>").append(transclude ? this._element : getCurrentTemplateEngine().render(this._compiledTemplate, options.model, options.index)).contents();
    }
  }, {
    key: "source",
    value: function source() {
      return $(this._element).clone();
    }
  }]);

  return Template;
}(TemplateBase);